// Module
var code = "<div layout=\"column\" class=\"full-height\"> <vehicles-table flex vehicles=\"$ctrl.agent.vehicles\" on-click=\"$ctrl.onVehicleSelect(vehicle)\" on-delete=\"$ctrl.onVehicleRemove(vehicle)\"> </vehicles-table> </div> ";
// Exports
export default code;